var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "footer-button",
      on: {
        click: function($event) {
          $event.stopPropagation()
          return _vm.toggleSearch.apply(null, arguments)
        }
      }
    },
    [
      _c(
        "svg",
        {
          attrs: {
            width: "20px",
            height: "20px",
            viewBox: "0 0 18 20",
            version: "1.1",
            xmlns: "http://www.w3.org/2000/svg",
            "xmlns:xlink": "http://www.w3.org/1999/xlink"
          }
        },
        [
          _c(
            "g",
            {
              attrs: {
                id: "Search-/-Explore",
                stroke: "none",
                "stroke-width": "1",
                fill: "none",
                "fill-rule": "evenodd"
              }
            },
            [
              _c(
                "g",
                {
                  attrs: {
                    id: "Main---New-Nav",
                    transform: "translate(-108.000000, -746.000000)",
                    stroke: "#000000",
                    "stroke-width": "1.2"
                  }
                },
                [
                  _c(
                    "g",
                    {
                      attrs: {
                        id: "Group-3",
                        transform: "translate(109.000000, 747.000000)"
                      }
                    },
                    [
                      _c("circle", {
                        attrs: { id: "Oval", cx: "6.8", cy: "6.8", r: "6.8" }
                      }),
                      _vm._v(" "),
                      _c("line", {
                        attrs: {
                          x1: "11.2",
                          y1: "12",
                          x2: "16",
                          y2: "17.6",
                          id: "Line-8",
                          "stroke-linecap": "round"
                        }
                      })
                    ]
                  )
                ]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("span", [_vm._v("Explore")])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6d2b2c13", { render: render, staticRenderFns: staticRenderFns })
  }
}